"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInput = TextInput;
var _theme = require("@a1s/theme");
var _react = _interopRequireDefault(require("react"));
var _polished = require("polished");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Field = require("../Field");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Styled components
// -------------------------------------------------------------------------------------------------
const Container = _styledComponents.default.input`
  ${p => (0, _theme.adjustFontSizeTo)(p.theme.fontSizes[1])};

  background-color: ${p => p.theme.colors.antiFlashWhite};
  border-color: ${p => p.theme.colors.antiFlashWhite};
  border-radius: ${p => (0, _polished.rem)(p.theme.radii[1])};
  border-style: solid;
  border-width: ${(0, _polished.rem)(2)};
  color: ${p => p.theme.colors.raisinBlack};
  font-family: ${p => p.theme.ui.baseFont};
  outline: 0;
  padding: ${p => (0, _polished.rem)(p.theme.spacing[0])} ${p => (0, _polished.rem)(p.theme.spacing[1])};
  width: 100%;

  &:focus {
    background-color: ${p => p.theme.colors.white};
    border-color: ${p => p.theme.colors.deepSkyBlue};
  }
`;

//
// Main component
// -------------------------------------------------------------------------------------------------
/**
 * A foundational component for inputting text into the app via a keyboard. The most basic use case is to plop down a
 * TextInput and subscribe to the `onChangeText` events to read the user input. There are also other events, such as
 * `onSubmitEditing` and `onFocus` that can be subscribed to.
 */
function TextInput(props) {
  const {
    disabled = false,
    id,
    multiline = false,
    name,
    placeholder,
    testID,
    value
  } = props;
  const {
    onBlur,
    onChange
  } = props;

  /**
   * If we're inside of a `<Field>` component, we can use its generated ID from its context.
   */
  const fieldId = (0, _Field.useField)();

  /**
   * Use a `<textarea>` element, if the input is marked as multiline.
   */
  const as = multiline ? 'textarea' : undefined;
  return /*#__PURE__*/_react.default.createElement(Container, {
    as: as,
    "data-testid": testID,
    disabled: disabled,
    id: id || fieldId // The passed-in `id` should always take precedence.
    ,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    placeholder: placeholder,
    value: value
  });
}